import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { Mood, RewardBanner } from '@intigral/shared';
import { MovieCard, Program } from '@intigral/ui';
import { SlideSkeleton } from '@intigral/ui/components/HeroBanner/SlideSkeleton';
import { IProgram } from '@intigral/ui/components/Program/ProgramWithoutPoster';
import { CarouselLoader } from '../components/Loader';
import { verticalPromoSlides } from '../features/promotion/constants/config';
import { __ } from '../translations';

// Don't import from the lazy rows here: it would pull them into this chunk
export const RowFallback = ({ carousel }: { carousel: Carousel }) => {
    switch (carousel?.wcpType || carousel?.type) {
        case 'HERO':
            return <SlideSkeleton />;
        case 'CONTINUE_WATCHING_LANDSCAPE':
            return (
                <CarouselLoader
                    title={__(carousel?.title_resource_key)}
                    swiperSettings={{ slidesPerView: 'auto', breakpoints: {} }}
                >
                    <Program program={{ isLoading: true } as IProgram} variant="card" />
                </CarouselLoader>
            );
        case 'VERTICAL_PROMOTION':
            return (
                <CarouselLoader swiperSettings={verticalPromoSlides}>
                    <MovieCard isLoading layout="vertical-2x" />
                </CarouselLoader>
            );
        case 'WATCHLIST_LANDSCAPE':
            return (
                <CarouselLoader>
                    <Mood isLoading />
                </CarouselLoader>
            );
        case 'HORIZONTAL_MLP_BANNER':
        case 'REWARD_BANNER':
            return (
                <div className="container full-width">
                    <RewardBanner isLoading />
                </div>
            );
        default:
            return null;
    }
};
